import AddIcon from './add';
export default AddIcon;
